@import 'apps/webcomponents/src/assets/common.scss';

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }

  .header-buttons {
    padding-right: calc(2 * var(--spacer));
    margin-right: calc(2 * var(--spacer));
    position: relative;
  }
}

.dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
}

.red-dot {
  background-color: red;
}

.green-dot {
  background-color: green;
}
